import { render, staticRenderFns } from "./SsoStart.vue?vue&type=template&id=c18a4c8a&scoped=true"
import script from "./SsoStart.vue?vue&type=script&lang=js"
export * from "./SsoStart.vue?vue&type=script&lang=js"
import style0 from "./SsoStart.vue?vue&type=style&index=0&id=c18a4c8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18a4c8a",
  null
  
)

export default component.exports